import { gql } from "graphql-tag";
import { basePaginationGraphql, baseResponseGraphql } from "../base.graphql";

export const mentorshipSectionFields = `
            id
            uniqueId
            createdDate
            isActive
            content
            order
            contentSection
        
`;

export const cardeMetricFields = `
id
uniqueId
cardeMetric {
  id
  uniqueId
  criteria
}`;

export const mentorshipCardeFields = `
           id
            uniqueId
            createdDate
            isActive
            cardeName {
                id
                uniqueId
                expertiseAbbreviation
                expertiseName
            }
            cardeTechnologies {
              isFramework
                id
                uniqueId
                name
            }
        
`;
export const skillsCardeFields = `
id
uniqueId
skill
`;

export const skillsMentorshipFields = `
             id
            uniqueId
            createdDate
            isActive
            skillName
        
        
`;
export const generalevaluationMetricsFields = `
              id
            uniqueId
            createdDate
            isActive
            categoryName
        
        
`;

export const MetricsFields = `
               id
            uniqueId
            criteria
        
        
`;
export const skillsFields = `
            id
            uniqueId
            createdDate
            isActive
           skillName

`;

export const evaluationMetricsFields = `
id
            uniqueId
            criteria
        
        
`;

//MENTORSHIP GUIDLINES
export const createMentorshipSectionGuideline = gql`
mutation CreateMentorshipSectionGuideline($input: GuidelinesSectionInputObject!){
    createMentorshipSectionGuideline(input: $input){
      ${baseResponseGraphql}
      data{
        ${mentorshipSectionFields}
      }
    }
  }
`;

export const updateMentorshipSectionGuideline = gql`
mutation UpdateMentorshipSectionGuideline($input: GuidelinesSectionInputObject!){
    updateMentorshipSectionGuideline(input: $input){
      ${baseResponseGraphql}
      data{
        ${mentorshipSectionFields}
      }
    }
  }
`;

export const getAllMentorshipGuidelinesSections = gql`
query GetAllMentorshipGuidelinesSections($filtering: GuidelinesSectionFilteringObject) {
  getAllMentorshipGuidelinesSections(filtering: $filtering) {
    ${baseResponseGraphql}
    ${basePaginationGraphql}
    data {
      ${mentorshipSectionFields}
    }
  }
}`;

export const deleteMentorshipSectionGuideline = gql`
mutation DeleteMentorshipSectionGuideline($uniqueId: String!){
  deleteMentorshipSectionGuideline(uniqueId: $uniqueId){
    ${baseResponseGraphql}
  }
}
  `;

//MENTORSHIPCARDE
export const createMentorshipCardeMutation = gql`
mutation CreateMentorshipCarde($input: MentorshipCardeInputObject!){
    createMentorshipCarde(input: $input){
      ${baseResponseGraphql}
      data{
        ${mentorshipCardeFields}
      }
    }
  }
`;

export const updateMentorshipCardeMutation = gql`
mutation UpdateMentorshipCarde($input: MentorshipCardeInputObject!){
    updateMentorshipCarde(input: $input){
      ${baseResponseGraphql}
      data{
        ${mentorshipCardeFields}
      }
    }
  }
`;

export const getAllMentorshipCardesQuery = gql`
query GetAllMentorshipCardes($filtering: MentorshipCardeFilteringInputObject) {
  getAllMentorshipCardes(filtering: $filtering) {
    ${baseResponseGraphql}
    ${basePaginationGraphql}
    data {
      ${mentorshipCardeFields}
    }
  }
}`;

export const deleteMentorshipCardeMutation = gql`
mutation DeleteMentorshipCarde($uniqueId: String!){
  deleteMentorshipCarde(uniqueId: $uniqueId){
    ${baseResponseGraphql}
  }
}
  `;

//skills carde

export const createCardeSkillMutation = gql`
   mutation CreateCardeSkill($input: CardeMentorshipSkillInputObject!){
       createCardeSkill(input: $input){
         ${baseResponseGraphql}
         data{
           ${skillsCardeFields}
         }
       }
     }
   `;

export const updateCardeSkillMutation = gql`
mutation UpdateCardeSkill($input: UpdateCardeSkillInputObject!) {
  updateCardeSkill(input: $input) {
         ${baseResponseGraphql}
         data{
           ${skillsCardeFields}
         }
       }
     }
   `;


export const getAllCardeSkillQuery = gql`
   query GetAllCardeSkill($filtering: CardeMentorshipSkillFilteringInputObject) {
     getAllCardeSkill(filtering: $filtering) {
       ${baseResponseGraphql}
       data {
         ${skillsCardeFields}
       }
     }
   }`;

export const deleteCardeSkillMutation = gql`
   mutation DeleteCardeSkill($uniqueId: String!){
     deleteCardeSkill(uniqueId: $uniqueId){
       ${baseResponseGraphql}
     }
   }
     `;

export const getMentorshipGuidelinesSummary = gql`
  query GetMentorshipGuidelinesSummary {
    getMentorshipGuidelinesSummary {
      response {
        id
        status
        code
        message
      }
      data {
        guidelineSection {
          id
          uniqueId
          content
          contentSection
          order
        }
        cardeSection {
          id
          uniqueId
          name
          abbreviation
          technologies {
            id
            uniqueId
            name
            isFramework
            category {
              id
              uniqueId
              name
            }
          }
          skills {
            id
            uniqueId
            skillName
          }
          evaluationMetrics {
            id
            uniqueId
            criteria
          }
        }
        generalEvaluationMetric {
          id
          uniqueId
          categoryName
          metrics {
            id
            uniqueId
            criteria
          }
        }
      }
    }
  }
`;

//SKILLS MENTORSHIP
export const getAllSkillsMentorshipQuery = gql`
     query GetAllSkillsMentorship($filtering: SkillMentorshipFilteringInput) {
       getAllSkillsMentorship(filtering: $filtering) {
         ${baseResponseGraphql}
         ${basePaginationGraphql}
         data {
           ${skillsMentorshipFields}
         }
       }
     }`;

export const deleteSkillsMentorship = gql`
  mutation DeleteSkillMentorship($uniqueId: String!) {
    deleteSkillMentorship(uniqueId: $uniqueId) {
      ${baseResponseGraphql}
    }
  }`;

//GENERAL EVALUATION

export const createGeneralEvaluationCategoryMutation = gql`
     mutation CreateGeneralEvaluationCategory($input: GeneralEvaluationCategoryInputObject!){
         createGeneralEvaluationCategory(input: $input){
           ${baseResponseGraphql}
           data{
             ${generalevaluationMetricsFields}
           }
         }
       }
     `;

export const updateGeneralEvaluationCategoryMutation = gql`
     mutation UpdateGeneralEvaluationCategory($input: GeneralEvaluationCategoryInputObject!){
         updateGeneralEvaluationCategory(input: $input){
           ${baseResponseGraphql}
           data{
             ${generalevaluationMetricsFields}
           }
         }
       }
     `;

export const getAllGeneralEvaluationCategoryQuery = gql`
     query GetAllGeneralEvaluationCategory($filtering: GeneralEvaluationCategoryFilteringInputObject) {
       getAllGeneralEvaluationCategory(filtering: $filtering) {
         ${baseResponseGraphql}
         ${basePaginationGraphql}
         data {
           ${generalevaluationMetricsFields}
         }
       }
     }`;

export const deleteGeneralEvaluationCategory = gql`
     mutation DeleteGeneralEvaluationCategory($uniqueId: String!){
       deleteGeneralEvaluationCategory(uniqueId: $uniqueId){
         ${baseResponseGraphql}
       }
     }
       `;

//GENERAL EVALUATION METRICS

export const createGeneralEvaluationMetricMutation = gql`
mutation CreateGeneralEvaluationMetric($input: GeneralEvaluationMetricInputObject!){
    createGeneralEvaluationMetric(input: $input){
      ${baseResponseGraphql}
      data{
        ${evaluationMetricsFields}
      }
    }
  }
`;

export const updateGeneralEvaluationMetricMutation = gql`
mutation UpdateGeneralEvaluationMetric($input: GeneralEvaluationMetricInputObject!){
    updateGeneralEvaluationMetric(input: $input){
      ${baseResponseGraphql}
      data{
        ${evaluationMetricsFields}
      }
    }
  }
`;

export const getAllGeneralEvaluationMetricsQuery = gql`
query GetAllGeneralEvaluationMetrics($filtering: GeneralEvaluationMetricFilteringInput) {
  getAllGeneralEvaluationMetrics(filtering: $filtering) {
    ${baseResponseGraphql}
    ${basePaginationGraphql}
    data {
      ${evaluationMetricsFields}
    }
  }
}`;

export const deleteGeneralEvaluationMetricMutation = gql`
mutation DeleteGeneralEvaluationMetric($input: DeleteGeneralEvaluationMetricInputObject!){
  deleteGeneralEvaluationMetric(input: $input){
    ${baseResponseGraphql}
  }
}
  `;

//CADRE EVALUATION METRICS

export const createCardeEvaluationMetric = gql`
mutation CreateCardeEvaluationMetric($input: CardeEvaluationMetricInputObject!) {
  createCardeEvaluationMetric(input: $input) {
    data {
      ${cardeMetricFields}
    }
   ${baseResponseGraphql}
  }
}`


export const updateCardeEvaluationMetric = gql`
mutation UpdateCardeEvaluationMetric($input: CardeEvaluationMetricInputObject!){
    updateCardeEvaluationMetric(input: $input){
      ${baseResponseGraphql}
      data {
        ${cardeMetricFields}
      }
    }
  }
`;

export const getAllCardeEvaluationMetric = gql`
query GetAllCardeEvaluationMetric($filtering: CardeEvaluationMetricFilteringInput) {
  getAllCardeEvaluationMetric(filtering: $filtering) {
    ${baseResponseGraphql}
    ${basePaginationGraphql}
      data {
        ${cardeMetricFields}
      }
  }
}`;

export const deleteCardeEvaluationMetric = gql`
mutation DeleteCardeEvaluationMetric($input: DeleteCardeEvaluationMetricInputObject!) {
  deleteCardeEvaluationMetric(input: $input) {
    ${baseResponseGraphql}
  }
}`;


//EVALUATION METRICS

export const createEvaluationMetricMutation = gql`
mutation CreateEvaluationMetric($input: EvaluationMetricInputObject!){
    createEvaluationMetric(input: $input){
      ${baseResponseGraphql}
      data{
        ${MetricsFields}
      }
    }
  }
`;

export const updateEvaluationMetricMutation = gql`
mutation UpdateEvaluationMetric($input: EvaluationMetricInputObject!){
    updateEvaluationMetric(input: $input){
      ${baseResponseGraphql}
      data{
        ${MetricsFields}
      }
    }
  }
`;

export const deleteEvaluationMetricMutation = gql`
mutation DeleteEvaluationMetric($uniqueId: String!){
  deleteEvaluationMetric(uniqueId: $uniqueId){
    ${baseResponseGraphql}
  }
}
  `;
export const getAllEvaluationMetricQuery = gql`
query GetAllEvaluationMetric($filtering: EvaluationMetricFilteringInput) {
  getAllEvaluationMetric(filtering: $filtering) {
    ${baseResponseGraphql}
    ${basePaginationGraphql}
    data {
      ${MetricsFields}
    }
  }
}`;

//MENTORSHIP SKILLS

export const createSkillMentorshipMutation = gql`
mutation CreateSkillMentorship($input: SkillMentorshipInputObject!){
    createSkillMentorship(input: $input){
      ${baseResponseGraphql}
      data{
        ${skillsFields}
      }
    }
  }
`;

export const updateSkillMentorshipMutation = gql`
mutation UpdateSkillMentorship($input: SkillMentorshipInputObject!){
    updateSkillMentorship(input: $input){
      ${baseResponseGraphql}
      data{
        ${skillsFields}
      }
    }
  }
`;

export const deleteSkillMentorshipMutation = gql`
mutation DeleteSkillMentorship($uniqueId: String!){
  deleteSkillMentorship(uniqueId: $uniqueId){
    ${baseResponseGraphql}
  }
}
  `;
export const getAllSkillsMentorship = gql`
query GetAllSkillsMentorship($filtering: SkillMentorshipFilteringInput) {
  getAllSkillsMentorship(filtering: $filtering) {
    ${baseResponseGraphql}
    ${basePaginationGraphql}
    data {
      ${skillsFields}
    }
  }
}`;


export const createCardeTechnology = gql`
mutation CreateCardeTechnology($input: CardeTechnologyInputObject!) {
  createCardeTechnology(input: $input) {
    data {
      id
      uniqueId
      name
      category {
        id
        uniqueId
        name
      }
      isFramework
    }
    ${baseResponseGraphql}
  }
}`

export const deleteCardeTechnology = gql`mutation DeleteCardeTechnology($input: DeleteCardeTechnologyInputObject!) {
    deleteCardeTechnology(input: $input) {
        data {
            id
            uniqueId
            technology {
                id
                uniqueId
                name
                isFramework
                category {
                    id
                    uniqueId
                    name
                }
            }
        }
    ${baseResponseGraphql}
    }
}
`

export const getAllCardeTechnlogies = gql`
query GetAllCardeTechnlogies($filtering: CardeTechnologyFilteringInputObject!) {
  getAllCardeTechnlogies(filtering: $filtering) {
    ${baseResponseGraphql}
    ${basePaginationGraphql}
    data {
      id
      uniqueId
      name
      category {
        id
        uniqueId
        name
      }
      isFramework
    }
  }
}`
